import { useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { GeometrisOdometerInput } from "../../../common/data/service-proxies";
import { HookFormSimpleForm } from "../../common/form/hook-form/HookFormSimpleForm";
import { HookFormTextInput } from "../../common/form/hook-form/inputs/HookFormTextInput";
import { GeometrisDeviceSelectorInput } from "./GeometrisDeviceSelectorInput";

interface Props {}

export const GeometrisResetOdometerCommandForm = (props: Props) => {
  const translate = useTranslate();
  const { control } = useFormContext<GeometrisOdometerInput>();
  return (
    <HookFormSimpleForm {...props}>
      <GeometrisDeviceSelectorInput<GeometrisOdometerInput>
        {...props}
        control={control}
      />
      <HookFormTextInput<GeometrisOdometerInput>
        {...props}
        control={control}
        name="value"
        label="Odometer value"
        rules={{ required: translate("ra.validation.required") }}
        options={{ InputProps: { type: "number" } }}
      />
    </HookFormSimpleForm>
  );
};
